import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewDisponibilizacaoPeriodos from "../views/ViewDisponibilizacaoPeriodos";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerComponente = styled.div`
  min-height: 100vh; /* Garante altura total da tela */
  display: flex;
  flex-direction: column;
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
    padding-bottom: 80px;
  }
`;

const MainContent = styled.div`
  flex: 1; /* Ocupa o espaço restante, empurrando o rodapé */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;
`;

const DisponibilizacaoPeriodos: React.FC = () => (
  <ContainerComponente>
    <ViewAppBar />
    <MainContent>
      <ViewDisponibilizacaoPeriodos />
    </MainContent>
    <ViewFooter />
  </ContainerComponente>
);

export default DisponibilizacaoPeriodos;
